import { render, staticRenderFns } from "./ModalFeedback.vue?vue&type=template&id=25e08a48&scoped=true&"
import script from "./ModalFeedback.vue?vue&type=script&lang=js&"
export * from "./ModalFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ModalFeedback.vue?vue&type=style&index=0&id=25e08a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e08a48",
  null
  
)

export default component.exports